import React from "react";
import styles from "src/components/molecules/SocialLinks/styles.module.css";
import Tiktok from "src/assets/icons/tiktok.svg";
import Youtube from "src/assets/icons/youtube.svg";
import Telegram from "src/assets/icons/telegram.svg";
import Instagram from "src/assets/icons/instagram.jpeg";
import TiktokBlack from "src/assets/icons/tiktokBlack.svg";
import YoutubeBlack from "src/assets/icons/youtubeBlack.svg";
import TelegramBlack from "src/assets/icons/telegramBlack.svg";
import InstagramBlack from "src/assets/icons/instagramBlack.svg";
import { useTheme } from "src/context/ThemeContext";
import { useGetSocialLinks } from "src/queries/useGetSocialLinks";
import { SocialLinks as SocialLinksData } from "src/api/user/profile";

const NETWORKS: {
  key: keyof SocialLinksData;
  light: string;
  dark: string;
}[] = [
  { key: "tiktok", light: Tiktok, dark: TiktokBlack },
  { key: "instagram", light: Instagram, dark: InstagramBlack },
  { key: "youtube", light: Youtube, dark: YoutubeBlack },
  { key: "telegram", light: Telegram, dark: TelegramBlack },
];

type Props = {
  className?: string;
};

/**
 * Иконки соцсетей в футере. Ссылки настраиваются в админке
 * («Настройки платформы»), у RU- и EN-версии сайта свои наборы.
 * Иконка с пустой ссылкой скрыта; пока не заполнено ничего —
 * показываются все иконки без ссылок (как до появления настройки).
 */
export const SocialLinks: React.FC<Props> = ({ className }) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const { socialLinks } = useGetSocialLinks();

  const hasAnyLink = NETWORKS.some(({ key }) => socialLinks?.[key]);

  return (
    <div className={className}>
      {NETWORKS.map(({ key, light, dark }) => {
        const href = socialLinks?.[key] ?? "";
        const icon = <img src={isDark ? dark : light} alt={key} />;

        if (href) {
          return (
            <a
              key={key}
              className={styles.socialLink}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {icon}
            </a>
          );
        }

        if (hasAnyLink) {
          return null;
        }

        return <React.Fragment key={key}>{icon}</React.Fragment>;
      })}
    </div>
  );
};
